module.exports = {
    baseUrl:'https://api.go4merchandise.com/',   
    baseUrlImg:'https://go4m-products.s3.ap-south-1.amazonaws.com/SKU_new/',   
   // baseUrl:'http://localhost:52404/'    
}


